import React from "react";

const Competencies = () => {
    return (
      <div className="competencies">
        <h3>Content Specialties</h3>
        <ul className="content-list">
          <li>Thought leadership and executive communications</li>
          <li>AI, technology and emerging innovation</li>
          <li>Law, ADR and governance topics</li>
          <li>Blogs, articles and educational content</li>
          <li>Annual reports and long-form organizational storytelling</li>
          <li>Interview-driven features and narrative writing</li>
        </ul>
      </div>
    );
};

export default Competencies;